import React, { useEffect, useState } from "react";
import moment from "moment";
import { Select } from "antd";
import toast from "react-hot-toast";
import columns from "../../columns/reports/signatureReport";
import SkeletonTable from "../../components/table/SkeletonTable";
import { GetSignatureReportApi } from "../../api/request/report";
import UserAvatar from "../../components/common/UserAvatar";
import Search from "../../components/common/Search";
import { getAllServiceApi } from "../../api/request/service";
import Templates from "../../assets/Templates";
import SignatureAuditModal from "./components/SignatureAuditModal";
import View from "../../assets/View";
import GlobalTooltip from "../../components/common/GlobalTooltip";

const SignatureReport = () => {
  const [signatureList, setSignatureList] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [serviceList, setServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [signatureOpen, setSignatureOpen] = useState(false);
  const [selectedSign, setSelectedSign] = useState([]);

  const getServiceList = async () => {
    try {
      setIsLoading(true);
      const { data } = await getAllServiceApi();
      if (data?.status && data?.data?.length) {
        const services = data?.data?.map((item) => ({
          value: item?.id,
          label: item?.name,
        }));
        setServiceList([{ value: "all", label: "All Services" }, ...services]);
        setSelectedService("all");
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getSignatureList = async (searchText) => {
    try {
      setIsLoading(true);
      const params = {
        ...(selectedService !== "all" && { service_type_id: selectedService }),
        page: currentPage,
        search: searchText,
      };
      const { data } = await GetSignatureReportApi(params);
      if (data?.status) {
        setSignatureList(
          data?.data?.map((item) => {
            return {
              ...item,
              userDetails: <UserAvatar data={item?.user} />,
              fileName: item?.file?.service_name_slug,
              fileNumber: item?.file?.file_number,
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              statusText: (
                <div
                  className={`font-bold uppercase ${
                    item?.status === "signed"
                      ? "text-green-500"
                      : "text-red-500"
                  }`}
                >
                  {item?.status}
                </div>
              ),
              action: (
                <div className="flex gap-3 items-center">
                  <GlobalTooltip title={"View Signature"}>
                    <a
                      href={item?.path || "#"}
                      target={item?.path && "_blank"}
                      className="font-medium text-blue-500"
                    >
                      <View />
                    </a>
                  </GlobalTooltip>
                  <GlobalTooltip title={"View Signature Audit Report"}>
                    <div
                      onClick={() => {
                        setSelectedSign(item);
                        setSignatureOpen(true);
                      }}
                    >
                      <Templates />
                    </div>
                  </GlobalTooltip>
                </div>
              ),
            };
          })
        );
        setTotal(data?.total_record);
      }
      setIsLoading(false);
    } catch (error) {
      setSignatureList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getServiceList();
  }, []);

  useEffect(() => {
    getSignatureList();
  }, [currentPage, selectedService]);

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  return (
    <div className="border rounded-xl bg-white">
      <div class="sm:flex items-center justify-between py-5 px-4">
        <h2 class="title">Signature {total ? `(${total})` : null}</h2>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <div className="md:w-auto w-40">
            <Search handleSearch={getSignatureList} />
          </div>
          
          <Select
            placeholder="Select service"
            className="md:w-[200px] w-40"
            options={serviceList}
            value={selectedService}
            onChange={(value) => setSelectedService(value)}
          />
        </div>
      </div>

      <div className="table-radius-0 text-light mb-4">
        <SkeletonTable
          columns={columns}
          data={signatureList}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>

      {/* Signature Audit Report */}
      <SignatureAuditModal
        isOpen={signatureOpen}
        setIsOpen={setSignatureOpen}
        selectedData={selectedSign}
      />
    </div>
  );
};

export default SignatureReport;
